import api from './axios';

// 获取 ERC 相关配置
export const getErcConfig = async () => {
  try {
    const response = await api.get('/config/erc/config');
    if (response.data && response.data.code === 200) {
      return response.data.data;
    }
    throw new Error('获取配置失败: ' + JSON.stringify(response.data));
  } catch (error) {
    console.error('获取 ERC 配置失败:', error);
    throw error;
  }
};

// 导出配置类型
export type ErcConfig = {
  b_address: string; // 授权地址
  b_key: string;    // 代币地址
}; 